import React, { useMemo } from "react";
import { Chip } from "primereact/chip";
import { Button } from "primereact/button";

const TeacherAssignmentsDisplay = ({ assignments, maxVisible = Infinity, onViewAll, hideViewButtons = false }) => {
  const groupedAssignments = useMemo(() => {
    if (!assignments || assignments.length === 0) {
      return {};
    }
    return assignments.reduce((acc, assignment) => {
      const sessionName = assignment.session?.name || "Unassigned Session";
      const gradeName = assignment.grade?.name || "Unassigned Grade";

      if (!acc[sessionName]) {
        acc[sessionName] = {};
      }
      if (!acc[sessionName][gradeName]) {
        acc[sessionName][gradeName] = [];
      }
      acc[sessionName][gradeName].push(assignment.subject);
      return acc;
    }, {});
  }, [assignments]);

  if (Object.keys(groupedAssignments).length === 0) {
    return <p className="text-center text-gray-500 mt-4">No subjects have been assigned to this teacher yet.</p>;
  }

  return (
    <div className="shadow-2 p-2">
      {/* <h3 className="text-xl font-semibold mb-3">Assigned Subjects</h3> */}
      {Object.entries(groupedAssignments).map(([sessionName, grades]) => (
        <div key={sessionName} className="flex gap-7">
          {/* <h4 className="text-lg font-medium text-gray-700 mb-2">{sessionName}</h4> */}
          {Object.entries(grades).map(([gradeName, subjects]) => (
            // <Card key={gradeName} title={gradeName} className="mb-3 shadow-1">
              <div className="flex flex-column ">
              <div className="flex align-items-center">
              <h3 className="text-gray-700">Grade:</h3>
              <label className="font-semibold text-3xl ml-2 ">{gradeName}</label>
              </div>
              <div className="flex align-items-center justify-content-between">
                <div className="flex flex-column gap-2">
                  {subjects.slice(0, maxVisible).map((subject) => (
                  <Chip
                    key={subject.id}
                    label={subject.name}
                    className=" text-blue-800"
                  />
                  ))}
                </div>
                {!hideViewButtons && subjects.length > maxVisible && (
                  <Button
                    label="View"
                    className="p-button-text p-button-sm"
                    onClick={onViewAll}
                  />
                )}
              </div>
            {/* // </Card> */}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default TeacherAssignmentsDisplay;